import styles from "./styles.module.scss";
import React, { FunctionComponent, useEffect, useState } from "react";
import { Card, Stack, useTheme } from "@mui/material";
import { useGetImage } from "../../../../hooks/images";
import { StatusCodesHelper } from "../../../../models/StatusCodesHelper";
import { ImageCache } from "../../../../models/ImageCache";
import { LazyImageAspectFit } from "../../../LazyImageAspectFit";
import { strings } from "../../../../localization/LocalizedStrings";
import { Icon, IconType } from "../../../../icons";
import { IGearItem } from "../../../../hooks/gearItems";
import { ToolbarButton } from "../../../toolbar/ToolbarButton";

export const GearItemListItem: FunctionComponent<IGearItemListItemProps> = ({
  gearItem,
  onDelete
}) => {
  const theme = useTheme();
  const { getImage } = useGetImage();
  const [image, setImage] = useState();
  const [imageUpdateCount, setImageUpdateCount] = useState(0);
  const genericImage = new URL("../../../../images/generic_label.png", import.meta.url).href;
  const fetchImage = async () => {
    if (!gearItem.hasImage) return;
    const response = await getImage({
      name: gearItem.uuid,
      width: ImageCache.bigLabelImageSize,
      height: ImageCache.bigLabelImageSize
    });
    if (StatusCodesHelper.isSuccessful(response.status)) {
      setImage(response.body);
    }
  };
  useEffect(() => {
    if (imageUpdateCount > 0) {
      setImage(undefined);
      fetchImage().then();
    } else {
      setImageUpdateCount(state => state + 1);
    }
  }, [gearItem]);
  return (
    <div
      className={styles.container}
      style={{
        height: 60,
        display: "flex",
        flexDirection: "row",
        backgroundColor: theme.palette.colors.buttonBackground
      }}
    >
      <Icon
        className={styles.dragIcon}
        style={{ color: theme.palette.secondary.main }}
        type={IconType.DragIndicator}
      />
      <Stack className={styles.imageStack} alignItems={"center"} justifyContent={"center"}>
        {gearItem.hasImage ? (
          <LazyImageAspectFit
            className={styles.image}
            imageStyle={{ borderRadius: "16px" }}
            image={image}
            thumbnail={gearItem.thumbnail}
            defaultImage={genericImage}
            beforeLoad={fetchImage}
            alt={gearItem.name}
          />
        ) : (
          <Card className={styles.defaultIcon}>
            <Icon type={IconType.AudioVideoReceiver} />
          </Card>
        )}
        {gearItem.status === "inactive" && (
          <Card style={{ marginTop: -2, backgroundColor: theme.palette.colors.goldmineGray }}>
            <p className={styles.inactiveCard}>{strings.status_inactive}</p>
          </Card>
        )}
      </Stack>
      <Stack className={styles.rightContainer}>
        <p className={styles.name}>{gearItem.name}</p>
        <p className={styles.brand}>{gearItem.brand}</p>
        <p className={styles.profile}>{gearItem.description}</p>
      </Stack>
      <ToolbarButton
        onClick={onDelete}
        tooltip={strings.delete}
        iconType={IconType.DeleteForever}
        color={theme.palette.colors?.remove}
      />
    </div>
  );
};

export interface IGearItemListItemProps {
  gearItem: IGearItem;
  onDelete: () => void;
}
